var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L13.75 13.75",
    transform: "translate(-1105.000000, -1588.000000) translate(318.000000, 360.000000) translate(0.000000, 689.000000) translate(0.000000, 533.000000) translate(550.000000, 0.000000) translate(231.000000, 0.000000) translate(6.000000, 6.000000) translate(4.125000, 4.125000) translate(6.875000, 6.875000) scale(-1, 1) rotate(90.000000) translate(-6.875000, -6.875000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L13.75 13.75",
    transform: "translate(-1105.000000, -1588.000000) translate(318.000000, 360.000000) translate(0.000000, 689.000000) translate(0.000000, 533.000000) translate(550.000000, 0.000000) translate(231.000000, 0.000000) translate(6.000000, 6.000000) translate(4.125000, 4.125000) translate(6.875000, 6.875000) rotate(90.000000) translate(-6.875000, -6.875000)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/white-cross.8999a8db514f49781bed1700167b70f3.svg";
export { ForwardRef as ReactComponent };